import React, { useState } from 'react';

const SpecialityModal = ({ formData, onChange, onSave, editId }) => {
  const [validatedFields, setValidatedFields] = useState({
    speciality_name: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mark all fields as validated when submitting
    const allFieldsValidated = Object.keys(validatedFields).reduce((acc, field) => {
      acc[field] = true;
      return acc;
    }, {});
    setValidatedFields(allFieldsValidated);

    // Check if all required fields are filled
    const isFormValid = Object.keys(validatedFields).every(
      field => !!formData[field]
    );

    if (isFormValid) {
      onSave();
    }
  };

  const handleBlur = (fieldName) => {
    if (!validatedFields[fieldName]) {
      setValidatedFields(prev => ({
        ...prev,
        [fieldName]: true
      }));
    }
  };

  const shouldShowValidation = (fieldName) => {
    return validatedFields[fieldName] && !formData[fieldName];
  };

  return (
    <div
      id="bs-specialities"
      className="modal fade"
      tabIndex="-1"
      aria-labelledby="bs-specialities"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5 className="modal-title" id="myModalLabel">
              {editId ? 'Edit' : 'Add'} Speciality
            </h5>
            <button
              type="button"
              id="modalCloseBtn"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label>Speciality Name</label>
                    <input
                      type="text"
                      name="speciality_name"
                      className={`form-control ${shouldShowValidation('speciality_name') ? 'is-invalid' : ''}`}
                      value={formData.speciality_name || ''}
                      onChange={onChange}
                      onBlur={() => handleBlur('speciality_name')}
                      required
                    />
                    {shouldShowValidation('speciality_name') && (
                      <div className="invalid-feedback">Speciality name is required</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn mb-1 waves-effect waves-light btn-outline-danger"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn mb-1 waves-effect waves-light btn-primary"
              >
                {editId ? 'Update' : 'Save'} Speciality
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SpecialityModal;